


































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import moment from "moment";

import FormActionButton from "@/components/falcon/shared/FormActionButton.vue";
import FilterOptionsForm from "@/components/falcon/shared/FilterOptionsForm.vue";
import SortOptionsForm from "@/components/falcon/shared/SortOptionsForm.vue";
import PaginationOptionsForm from "@/components/falcon/shared/PaginationOptionsForm.vue";
import ComplaintsFiltersStateFormField from "@/components/falcon/complaints/ComplaintsFiltersStateFormField.vue";
import TableInlinePagination from "@/components/falcon/shared/TableInlinePagination.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { FalconFilterOptions } from "@/interfaces/falcon/shared/falcon-filter-options";
import { FalconSortOptions } from "@/interfaces/falcon/shared/falcon-sort-options";
import { FalconPaginationOptions } from "@/interfaces/falcon/shared/falcon-pagination-options";
import { GetMyComplaintsFalconRequest } from "@/interfaces/falcon/get-my-complaints/get-my-complaints-falcon-request";

import { FalconComplaintState } from "@/enums/falcon/complaints/falcon-complaint-state.enum";
import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaints forms component
 */
@Component({
  components: {
    TableInlinePagination,
    PaginationOptionsForm,
    FormActionButton,
    ComplaintsFiltersStateFormField,
    SortOptionsForm,
    FilterOptionsForm
  },
  filters: {
    ...capitalizeFilter
  }
})
export default class ComplaintsForms extends Vue {
  @Action("falconComplaints/getComplaints") private getComplaints!: (
    request: GetMyComplaintsFalconRequest
  ) => void;
  private filterOptions: FalconFilterOptions = {};
  private sortOptions: FalconSortOptions = {};
  private paginationOptions: FalconPaginationOptions = {};
  private complaintState: FalconComplaintState | null = null;

  @State(state => state.falconComplaints.complaintsTotalCount)
  complaintsTotalCount!: number;
  requestAliasEnum = RequestAlias;
  i18nMessageKeyEnum = I18nMessageKey;
  initialDateFrom = moment()
    .subtract(7, "d")
    .format("YYYY-MM-DD");

  mounted(): void {
    this.complaintsFetchRequested();
  }

  setFilterOptions(filterOptions: FalconFilterOptions): void {
    this.filterOptions = filterOptions;
    this.clearPaginationOptions();
  }

  setSortOptions(sortOptions: FalconSortOptions): void {
    this.sortOptions = sortOptions;
  }

  setComplaintState(complaintState: FalconComplaintState): void {
    this.complaintState = complaintState;
    this.clearPaginationOptions();
  }

  setPaginationOptions(paginationOptions: FalconPaginationOptions): void {
    this.paginationOptions = paginationOptions;
  }

  setPageSize(pageSize: number): void {
    this.setPaginationOptions({
      ...this.paginationOptions,
      pageSize
    });
  }

  setPageNumber(pageNumber: number): void {
    this.setPaginationOptions({
      ...this.paginationOptions,
      pageNumber
    });
    this.complaintsFetchRequested();
  }

  complaintsFetchRequested(): void {
    this.getComplaints({
      getMyComplaints: {
        state: this.complaintState as FalconComplaintState,
        filterOptions: this.filterOptions,
        sortOptions: this.sortOptions,
        ...this.paginationOptions
      }
    });
  }

  private clearPaginationOptions(): void {
    this.paginationOptions.pageNumber = 1;
  }
}
